import { Grid } from "@material-ui/core";

function AdblockMessage(props){
    return(
        <Grid container xs="12" md="12" direction="column" alignItems="center" justify="center" spacing={1} style={{paddingTop: '200px', position: 'absolute'}}>
          <Grid item>
            <div style={{"margin":"20px","backgroundColor":"white","padding":"10px","borderRadius":"4px","boxShadow":"0px 1px 6px #7784945e"}}>
              <span style={{fontWeight:'bold'}}>Ad Blocker Detected</span>
              <p style={{marginTop: '10px', marginBottom: '0'}}>
                We've noticed that you are using an ad-blocking browser extension or firewall. Please turn it off and refresh the page to use this plugin.
              </p>
              <p style={{marginTop: '10px', marginBottom: '0'}}>
                See <a href="https://help.adthrive.com/hc/en-us/articles/7103432288923#h_01G78CBWXMGMM667TCME0T4D8C" target="_blank">this support article</a> to learn how to turn off any ad-blocking browser extensions.
              </p>
            </div>
          </Grid>
        </Grid>
    );

}

export default AdblockMessage;